<template>
  <div class="full__cvr fx_ctr hcenter">
    <div class="compose__pot wbox">
      <div class="compose__pot--head fx_ctr">
        <button class="left__btn" v-on:click="goBack()"><font-awesome-icon icon="times" /></button>
        <p class="title">Potのタイトルを入力してください</p>
      </div>
      <div class="compose__pot--inner">
        <form action="">
          <input type="text" name="pot__name" class="pot__name" v-model="text" v-on:keyup.esc="goBack()" ref="potname">
        </form>
        <SubmitBtn :text="text" :func="putNewPot" :ariaLabel="'submit composing a pot.'">登録</SubmitBtn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { uuid } from 'vue-idb'
import dayjs from 'dayjs'
import SubmitBtn from '@/components/Atoms/SubmitBtn.vue';

export default {
  name: 'ComposePot',
  data() {
    return {
      text: '',
      potlist:[]
    }
  },
  created(){
  },
  components: {
    SubmitBtn
  },
  mounted(){
    this.$refs.potname.focus();
  },
  watch: {
    '$route' () {
      console.log(this.composePot);

      if(this.composePot === true){
        this.$refs.potname.focus();
      }
    }
  },
  computed: {
    ...mapGetters([
      'composePot', 'getPotsLast'
    ])
  },
  methods: {
    ...mapActions([
      'toggleComposePot', 'potsAdd'
    ]),
    goBack: function(){
      this.toggleComposePot()
      this.$router.go(-1);
    },
    putNewPot: async function(){
      const params = {
        author: null,
        status: 1,
        created_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ') ,
        updated_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ')
      }
      params.id = uuid()
      params.title = this.text

      await this.potsAdd(params)
      .then(()=>{
          this.toggleComposePot(false)
          this.$router.push({ name: 'PotDetail', params: {id: params.id}, force: true })
        }
      )
      const lastId = await this.getPotsLast
      console.log(lastId);

    }
  }
}
</script>

<style lang="scss">
.compose__pot{
  background: #FFF;
  width: 100%;
  min-width: 300px;
  max-width: 600px;
  .compose__pot--head{
    padding: 12px 16px;
    border-bottom: 1px solid #EEE;
    .title{
      width: 100%;
      font-size: 1.4rem;
    }
    .left__btn{
      display: inline-block;
      margin-right: 16px;
      font-size: 24px;
      padding: 0 9px;
    }
  }
  .compose__pot--inner{
    padding: 24px;
    .pot__name{
      font-size: 1.2rem;
      line-height: 1.6rem;
      border-bottom: 2px solid #0b7a29;
      width: 100%;
      margin: 0 0 16px;
      padding: 8px;
      &:focus{
        border-bottom: 2px solid #10b03b;
        outline: none;
      }
    }
    .btn{
      font-size: 1rem;
    }
  }
}
@media screen and (max-width: 648px){
  .compose__pot{
    margin: 16px;
    .compose__pot--head{
      .title{
        font-size: 1.2rem;
      }
    }
  }
}
</style>
